import axios from 'axios';
const configurationsUrl = process.env.REACT_APP_CONFIGURATIONS;

export const getTrainingNames = async (token, organizationId) => {
  const url = `${configurationsUrl}/v1/get-training-names`;

  const requestOptions = {
    method: 'GET',
    headers: {
      'Cache-Control': 'no-cache',
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `bearer ${token}`,
    },
    params: {
      organizationId,
    },
  };

  try {
    const response = await axios(url, requestOptions);
    return response.data || response;
  } catch (error) {
    console.error('getTrainingNames', error);
    throw error;
  }
};

export const deleteTrainingNames = async (params) => {
  try {
    const { token, documentId, dataToDelete } = params;
    const url = `${configurationsUrl}/v1/delete-many/subcollection`;
    const requestOptions = {
      method: 'POST',
      headers: {
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/json',
        Authorization: `bearer ${token}`,
      },
      data: {
        documentId,
        dataToDelete,
      },
    };
    await axios(url, requestOptions);
  } catch (error) {
    console.error('deleteTrainingNames', error);
    throw error;
  }
};
